export const safeDecodeUriComponent = (s: string) => {
    try {
        return decodeURIComponent(s)
    } catch (_e) {
        return s
    }
}

export const containsValidUriComponent = (valueToVerify: string) => {
    try {
        decodeURIComponent(valueToVerify)
        return true
    } catch (ex) {
        console.warn('[containsValidUriComponent]: ', ex, valueToVerify)
        return false
    }
}
